// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.sort-filter[data-v-f5aac0b2] {\n  background-color: transparent !important;\n}\n.sort-filter span[data-v-f5aac0b2] {\n  font-weight: 500;\n  color: var(--bluey-grey);\n  font-size: 0.93rem;\n}\n.active[data-v-f5aac0b2] {\n  color: var(--eggplant) !important;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
